import React, { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Typography from '@material-ui/core/Typography';

import apiFetch from '../../utils/apiUtils';
import Colors from '../../utils/colors';
import SortableDropdownSelect from '../SortableDropdownSelect';
import {DropdownContext, ErrorContext} from '../../utils/constants';

const useStyles = makeStyles(() => ({
    editorWrapper: {
        height: '100%',
        width: '66%',
        marginTop: '10px',
        marginBottom: '10px'
    },
    editorContainer: {
        backgroundColor: Colors.lightBlue,
    },
    editorContainerWarn: {
        backgroundColor: Colors.warange,
    },
    warningText: {
        textTransform: 'uppercase',
        fontWeight: 'bold',
        textAlign: 'center',
        paddingTop: '1.5rem'
    },
    formControl: {
      margin: '1rem',
      minWidth: 360
    },
    helpContainer: {
        padding: '2%',
        width: '33%',
        background: 'rgba(110, 247, 138, 0.1)',
        marginLeft: '2rem',
        marginTop: '0.5rem'
    },
    editorTextField: {
        width: '95%',
        backgroundColor: '#FFFFFF'
    },
    inline: {
        margin: '1rem',
        "&:hover": {
            backgroundColor: Colors.brightBlue,
            color: Colors.indigoBlue
          },
    },
    deleteButton: {
        color: Colors.indigoBlue,
        margin: '1rem 2rem 1rem 0',
        "&:hover": {
            backgroundColor: Colors.orangeRed,
            color: 'white'
          },
        
    }
}));

export default function ValueTypeSelection({ onCancel, onSuccess, impact, disabled }) {
    const classes = useStyles();
    const { id: initiativeId } = useParams();
    const [ valueType, setValueType ] = useState(impact ? impact.valueTypeId : '');
    const { triggerError } = useContext(ErrorContext);
    const { dropdowns } = useContext(DropdownContext);

    const handleValueTypeChange = event => {
        setValueType(event.target.value);
    };

    const submitValueType = async () => {
        return impact ?
            apiFetch(
                `/initiatives/${initiativeId}/values/${impact.id}/type`,
                'PUT',
                JSON.stringify({valueType}),
                onSuccess,
                () => triggerError({
                    title: 'Communication Error',
                    description: 'We were unable to update your value type. Please try again.',
                    onRetry: submitValueType
                })
            ) :
            apiFetch(
                `/initiatives/${initiativeId}/values`,
                'POST',
                JSON.stringify({valueType}),
                onSuccess,
                () => triggerError({
                    title: 'Communication Error',
                    description: 'We were unable to create your value. Please try again.',
                    onRetry: submitValueType
                })
            );
    };

    const deleteImpact = async () => {
        return apiFetch(
            `/initiatives/${initiativeId}/values/${impact.id}`,
            'DELETE',
            JSON.stringify({}),
            onSuccess,
            () => triggerError({
                title: 'Communication Error',
                description: 'We were unable to delete your value. Please try again.',
                onRetry: deleteImpact
            })
        );
    }
    const customSorter = (listArray) => {
        const returnArray = listArray.filter(item => item.value === 'Financial Metric');
        returnArray.push(listArray.find(item => item.value === 'Non-Financial Metric'));
        returnArray.push(listArray.find(item => item.value === 'Organizational Health'));
        returnArray.push(listArray.find(item => item.value === 'Sap Project Validation'));
        return returnArray;
    }

    return (
        <div style={{display: 'flex'}}>
            <div className={classes.editorWrapper}>
                <div className={impact ? classes.editorContainerWarn : classes.editorContainer}>
                    { impact && <div className={classes.warningText}>
                      CHANGING VALUE TYPE REMOVES PREVIOUSLY FILLED IN DATA!
                    </div>}
                    <SortableDropdownSelect
                        label='Metric Type'
                        labelId='impact-type-select-label'
                        controlClass={classes.formControl}
                        variant='outlined'
                        size='small'
                        fullWidth
                        selectClass={classes.editorTextField}
                        onChange={handleValueTypeChange}
                        value={valueType || ''}
                        dropdownName={'ValueType'}
                        disabled={disabled}
                        customSorter={customSorter}
                    />
                    <ButtonGroup fullWidth>
                        <Button
                            className={classes.inline}
                            onClick={submitValueType}
                            variant='contained'
                            color='primary'
                            disabled={disabled}
                        >
                            SUBMIT
                        </Button>
                        <Button
                            className={classes.inline}
                            variant='contained'
                            color='primary'
                            onClick={onCancel}
                        >
                            CANCEL
                        </Button>
                    </ButtonGroup>
                </div>
                {impact && <Button
                    fullWidth
                    onClick={deleteImpact}
                    variant='contained'
                    color='secondary'
                    className={classes.deleteButton}
                    disabled={disabled}
                >
                    DELETE VALUE
                </Button>}
            </div>
            <div className={classes.helpContainer}>
                <Typography variant='body2'>
                  Metric Type determines how your initiative will be measured.
                </Typography>

                <Typography variant='button'>
                    Financial Metric
                </Typography>
                <Typography variant='body2'>
                    Metrics used to reflect cost savings or new revenues across the organization.
                </Typography>
                <Typography variant='button'>
                    Non-Financial Metric
                </Typography>
                <Typography variant='body2'>
                    Non-cashflow metrics that measure work optimization and efficiency improvements.
                </Typography>
                <Typography variant='button'>
                    Organizational Health
                </Typography>
                <Typography variant='body2'>
                    Non-cashflow metrics that measure improvements in the way we work together, aligning with
                    TransAlta’s priority practices.
                </Typography>
                <Typography variant='button'>
                    SAP PROJECT VALIDATION
                </Typography>
                <Typography variant='body2'>
                    Cost savings or new revenues that can be pulled directly from SAP.
                </Typography>

            </div>
        </div>
    );
}
